function setupMethod(target, method) {
	function parseStackHosts(stackString) {
		return stackString
			.split(/\n/gm)
			.map(
				(line) =>
					(/^\s+at\s+([^(]+?\s+\()?https?:\/\/([^/]+)/.test(line) && RegExp.$2) || // Chromium stack format
					(/^([^(]+)?@https?:\/\/([^/]+)/.test(line) && RegExp.$2) || // Firefox/Safari stack format
					null // No matching format
			)
			.filter((host) => host);
	}

	function getCallingHost(stackString) {
		const hosts = parseStackHosts(stackString);
		return hosts[1];
	}

	function matchHost(hostPattern, host) {
		if (hostPattern === "'self'" && host === location.host) {
			return true;
		} else {
			const pattern = hostPattern.replace(/\*\./g, '([\\w-]+\\.)*');
			const regex = new RegExp(`^${pattern}$`);
			return regex.test(host);
		}
	}

	return function (e) {
		if (e.matches('style') && !e.hasAttribute('nonce')) {
			const host = getCallingHost(new Error().stack);
			const cspHosts = window.voltronCSPHosts;
			const voltronCSPHostsArray = Array.isArray(cspHosts) ? cspHosts : cspHosts.split(/\s+/g);
			const matches = voltronCSPHostsArray.filter((pattern) => matchHost(pattern, host));

			if (matches.length) {
				e.setAttribute('nonce', window.voltronNonce);
			}
		}
		method.call(target, ...arguments);
	};
}

document.body.appendChild = setupMethod(document.body, document.body.appendChild);
document.head.appendChild = setupMethod(document.head, document.head.appendChild);
document.head.insertBefore = setupMethod(document.head, document.head.insertBefore);
